import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import TraceableBarcode from "../../../controls/TraceableBarcode";
import TraceableLotNumber from "../../../controls/TraceableLotNumber";

export default function ReceivingSubTable2(props) {
  const { data, loadingRows, rowDetails, selectedItems, setSelectedItems } =
    props;

  const bodyProductName = (item) => {
    return (
      <div className="flex gap-2">
        {item.is_legacy === 1 ? <p className="text-lg my-auto">L</p> : null}
        <div>
          {item.product_name} <br />{" "}
          <span className="font-bold">PLU: {item.plu}</span>
        </div>
      </div>
    );
  };

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const subItemWeightData = (item) => {
    return (
      <p>
        {item.weight_in_kg} kg <br />
        {item.weight_in_lbs} lbs
      </p>
    );
  };

  const subItemPiecesData = (item) => {
    return <p>{item.piece_count} pieces</p>;
  };

  const totalCostData = (item) => {
    return <p>${item.total_cost}</p>;
  };

  const barcodeBody = (data) => <TraceableBarcode barcode={data.barcode} />;
  const lotNumberBody = (data) => (
    <TraceableLotNumber lotNumber={data.lot_number} traceType="supplier" />
  );

  const rowStyleClass = (data) => {
    return {
      "bg-cyan-100": data.pallet_id > 0,
      "bg-yellow-100": data.is_legacy === 1,
      "bg-gray-100": data.is_legacy === 0 && data.pallet_id < 1,
    };
  };

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm receiving-sub-items-table-2"
        cellClassName="py-2 border-1-bottom-gray px-2 text-sm"
        rowClassName={rowStyleClass}
      >
        <Column
          header="Product"
          body={bodyProductName}
          style={{ width: "20%" }}
        />
        <Column header="Lot Number" body={lotNumberBody} style={{ width: "10%" }} />
        <Column header="Barcode" body={barcodeBody} style={{ width: "20%" }} />
        <Column
          header="Weight"
          body={subItemWeightData}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Piece count"
          body={subItemPiecesData}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          header="Total cost"
          body={totalCostData}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column
          field="warehouse_location_name"
          header="Location"
          style={{ width: "10%" }}
        />
      </DataTable>
    </div>
  );
}
